(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.filter("sanitize", ['$sce', function($sce) {
      return function(htmlCode){
        return $sce.trustAsHtml(htmlCode);
      }
    }]);

    ngModule.controller('TabsCtrl', function TabsCtrl($scope, $rootScope, $window, SplashModalService) {

        var tpl = require('../templates/demo/sampleTable.html');
        $scope.tabs = [
          { title:'Dynamic Title 1', content:'Dynamic content 1' },
          { title:'Dynamic Title 2', content:'Dynamic content 2', disabled: true },
          { title:'Dynamic Title 3', content: tpl },
        ];

        $scope.alertMe = function() {
          setTimeout(function() {
            $window.alert('You\'ve selected the alert tab!');

          });
        };

        $scope.openSplashModal = function() {

            SplashModalService.open({
                btnText:'Close',
                title: 'Hi There!',
                message: "We're off to see the wizard, The Wonderful Wizard of Oz",
                templateUrl: './templates/demo/splashModalContent.html',
            });

        };

    });
})();
